import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("octa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  getToken: () => localStorage.getItem("octa_token"),
  getRole: () => localStorage.getItem("octa_role"),
  getUser: () => {
    const u = localStorage.getItem("octa_user");
    return u ? JSON.parse(u) : null;
  },
  setSession: (token, role, user) => {
    localStorage.setItem("octa_token", token);
    localStorage.setItem("octa_role", role);
    if (user) localStorage.setItem("octa_user", JSON.stringify(user));
  },
  clear: () => {
    localStorage.removeItem("octa_token");
    localStorage.removeItem("octa_role");
    localStorage.removeItem("octa_user");
  },
};
